//cspell:ignore nodrag nopan
import { useAtomValue } from 'jotai';
import { BaseEdge, EdgeLabelRenderer, EdgeProps, getBezierPath } from 'reactflow';

import { IconSvg } from '@/lib/v2/components';
import { CreateEdgeIcon } from '@/lib/v2/icons/solid';

import { atomIsTriggerFormComplete } from '@/src/modules/RulesModule/atoms/rules';

const SelectorEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}) => {
  const isTriggerFormComplete = useAtomValue(atomIsTriggerFormComplete);

  if (!isTriggerFormComplete) return null;

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge id={id} markerEnd={markerEnd} path={edgePath} style={style} />
      <EdgeLabelRenderer>
        <div
          data-id="add-condition-icon"
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
        >
          <IconSvg height="20px" svgComponent={<CreateEdgeIcon />} width="20px" />
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default SelectorEdge;
